export default __webpack_public_path__ + "static/SANTA_LIBRADA-3d63edbab414b3b252adc2b699e59b10.jpeg";